/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Provider_Rate_LimitedInputs */

const vi_einvoice_error_provider_rate_limited = /** @type {(inputs: Einvoice_Error_Provider_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang giới hạn số request. Vui lòng thử lại sau vài phút.`)
};

/**

* @param {Einvoice_Error_Provider_Rate_LimitedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_provider_rate_limited = /** @type {((inputs?: Einvoice_Error_Provider_Rate_LimitedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Provider_Rate_LimitedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_provider_rate_limited(inputs)
});